/* custom-product-slider.js
   Standalone product gallery slider — works independently of the theme's
   original Swiper init (which we couldn't locate). Handles:
   - Desktop main slider + thumbnail nav (product-page__slider-1.liquid)
   - Mobile slider (product-page-mobile-media.liquid)
   - Prev/next buttons, pagination dots, thumbnail clicks, swipe on touch
   - Click-to-zoom on the active main image, reset whenever the slide changes
*/
(function () {
  var ZOOM_SCALE = 1.8;

  function pointerOrigin(container, clientX, clientY) {
    var rect = container.getBoundingClientRect();
    var x = ((clientX - rect.left) / rect.width) * 100;
    var y = ((clientY - rect.top) / rect.height) * 100;
    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));
    return x + '% ' + y + '%';
  }

  function setupZoom(slide) {
    if (!slide.classList.contains('media-type-image')) return null;

    var img = slide.querySelector('img');
    if (!img) return null;

    var zoomed = false;

    function zoomOut() {
      if (!zoomed) return;
      zoomed = false;
      slide.classList.remove('is-zoomed');
      img.style.transform = '';
      img.style.transformOrigin = '';
    }

    function zoomIn(clientX, clientY) {
      zoomed = true;
      slide.classList.add('is-zoomed');
      img.style.transformOrigin = pointerOrigin(slide, clientX, clientY);
      img.style.transform = 'scale(' + ZOOM_SCALE + ')';
    }

    slide.addEventListener('click', function (e) {
      if (slide.dataset.justSwiped === 'true') {
        slide.dataset.justSwiped = 'false';
        return;
      }

      if (e.target.closest('.sf-prod-media__zoom-in')) {
        e.preventDefault();
      }

      if (zoomed) {
        zoomOut();
      } else {
        zoomIn(e.clientX, e.clientY);
      }
    });

    slide.addEventListener('mousemove', function (e) {
      if (!zoomed) return;
      img.style.transformOrigin = pointerOrigin(slide, e.clientX, e.clientY);
    });

    slide.addEventListener('mouseleave', zoomOut);

    return zoomOut;
  }

  function initSlider(root) {
    if (!root || root.dataset.sliderInit === 'true') return;

    var wrapper = root.querySelector('.swiper-wrapper.main-slider, .swiper-wrapper.mobile');
    if (!wrapper) return;

    root.dataset.sliderInit = 'true';

    var slides = Array.prototype.slice.call(wrapper.children).filter(function (el) {
      return el.classList.contains('swiper-slide');
    });
    if (slides.length === 0) return;

    var zoomResetters = slides.map(setupZoom).filter(Boolean);

    var scope =
      root.closest('.sf-pis__wrapper') ||
      root.closest('.product-mb__media') ||
      document;

    var thumbs = Array.prototype.slice.call(
      scope.querySelectorAll('.sf-media-nav .swiper-slide[data-index]')
    );
    var pagination = root.querySelector('.swiper-pagination');
    var current = 0;
    var isMobileCarousel = wrapper.classList.contains('mobile');

    // track = the array actually used for the centering math. On mobile we
    // prepend a clone of the last slide and append a clone of the first
    // slide, purely so the first/last real slide also has a "sliver" of a
    // neighbour to peek at, same as every other slide. Clones are not part
    // of `slides`, so pagination/thumbnails/zoom/active-state logic (which
    // all read from `slides`) is completely unaffected.
    var track = slides;
    var trackOffset = 0;

    if (isMobileCarousel && slides.length > 1) {
      var firstClone = slides[0].cloneNode(true);
      var lastClone = slides[slides.length - 1].cloneNode(true);

      [firstClone, lastClone].forEach(function (clone) {
        clone.classList.add('is-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(function (el) {
          el.removeAttribute('id');
        });
        clone.querySelectorAll('a, button, input, textarea, select').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
      });

      wrapper.insertBefore(lastClone, wrapper.firstChild);
      wrapper.appendChild(firstClone);

      track = [lastClone].concat(slides, [firstClone]);
      trackOffset = 1; // real index 0 now sits at track index 1
    }

    function positionMobileCarousel(index) {
      if (!isMobileCarousel) return;
      var slide = track[index + trackOffset];
      if (!slide) return;
      var offset = slide.offsetLeft - (root.clientWidth - slide.offsetWidth) / 2;
      wrapper.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
    }

    if (pagination) {
      pagination.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'sf-slider-dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', function () {
          goTo(i);
        });
        pagination.appendChild(dot);
      });
    }

    function normalizeIndex(index) {
      if (index < 0) return slides.length - 1;
      if (index >= slides.length) return 0;
      return index;
    }

    function goTo(index) {
      index = normalizeIndex(index);

      zoomResetters.forEach(function (reset) {
        reset();
      });

      slides[current].classList.remove('is-active');
      slides[index].classList.add('is-active');
      current = index;
      positionMobileCarousel(current);

      if (pagination) {
        Array.prototype.forEach.call(pagination.children, function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', Number(t.getAttribute('data-index')) === current);
      });
    }

    var prevBtn = root.querySelector('.swiper-button-prev');
    var nextBtn = root.querySelector('.swiper-button-next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.getAttribute('data-index')));
      });
    });

    // touch swipe support
    var touchStartX = 0;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    wrapper.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        var targetIndex = normalizeIndex(dx < 0 ? current + 1 : current - 1);
        var targetSlide = slides[targetIndex];
        targetSlide.dataset.justSwiped = 'true';
        // Safety net: most touch browsers skip the trailing click after a
        // real swipe, but if one slips through late, don't let the flag
        // block a later, genuine tap on this slide.
        setTimeout(function () { targetSlide.dataset.justSwiped = 'false'; }, 500);
        goTo(targetIndex);
      }
    }, { passive: true });

    goTo(0);

    if (isMobileCarousel) {
      window.addEventListener('resize', function () {
        positionMobileCarousel(current);
      });
    }

    // reveal thumbnail nav (theme keeps it at opacity-0 until a slider inits it)
    var nav = scope.querySelector ? scope.querySelector('.nav-swiper-container') : null;
    if (nav) nav.classList.remove('opacity-0');
  }

  function initAll() {
    document.querySelectorAll('.swiper-container').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();